package er.prateek.crossly.share

import er.prateek.crossly.firebase.AnalyticsLogger

object ShareFunnel {
    fun params(
        payload: SharePayload,
        extra: Map<String, String> = emptyMap(),
    ): Map<String, Any> {
        val env = browserEnvironment()
        val client = webClientFromUserAgent(env.userAgent)
        val built = buildMap {
            putTruncated("share_id", payload.shareId)
            putTruncated(
                "kind",
                when (payload.kind) {
                    SharePayload.Kind.CHALLENGE -> "challenge"
                    SharePayload.Kind.RESULT -> "result"
                    SharePayload.Kind.APP_SHARE -> "app_share"
                },
            )
            putTruncated("origin", payload.origin)
            putTruncated("puzzle_id", payload.puzzleId)
            putTruncated("surface", currentSurface())
            putTruncated("web_client", if (isWebRuntime()) client.name.lowercase() else "")
            putTruncated("lang", env.language)
            if (env.viewportWidth > 0) {
                putTruncated("viewport", "${env.viewportWidth}x${env.viewportHeight}")
            }
            if (env.timezoneOffsetMinutes != 0 || isWebRuntime()) {
                put("tz_offset", env.timezoneOffsetMinutes.toLong())
            }
            putTruncated("ua", env.userAgent)
            putTruncated("doc_referrer", env.documentReferrer)
            extra.forEach { (k, v) -> putTruncated(k, v) }
        }
        return built.filterValues { value ->
            when (value) {
                is String -> value.isNotEmpty()
                else -> true
            }
        }
    }

    fun log(
        analytics: AnalyticsLogger,
        name: String,
        payload: SharePayload,
        extra: Map<String, String> = emptyMap(),
    ) {
        analytics.logEvent(name, params(payload, extra))
    }

    private fun MutableMap<String, Any>.putTruncated(key: String, value: String) {
        if (value.isNotBlank()) put(key, value.take(100))
    }

    private fun currentSurface(): String = if (isWebRuntime()) "web" else currentShareOrigin()
}
